/**
 * bt-ebook-landing.js
 * Scroll animations, sticky CTA bar, and analytics events
 * for the ebook landing page template.
 */
document.addEventListener('DOMContentLoaded', function () {
  var firedEvents = new Set();

  // ─── Product data from hero section ───
  var hero = document.querySelector('[data-track="hero"]');
  var productData = {
    product_title: hero ? hero.getAttribute('data-product-title') : '',
    product_price: hero ? hero.getAttribute('data-product-price') : ''
  };

  // ─── Helpers ───
  function fireEvent(eventName, data) {
    if (firedEvents.has(eventName)) return;
    firedEvents.add(eventName);
    if (window.dataLayer) {
      window.dataLayer.push(Object.assign({ event: eventName }, data || {}));
    }
  }

  function fireMetaEvent(eventName, data) {
    if (typeof fbq === 'function') {
      fbq('track', eventName, data);
    }
  }

  // ─── Page load event ───
  fireEvent('ebook_landing_view', productData);
  fireMetaEvent('ViewContent', {
    content_type: 'ebook',
    content_name: productData.product_title,
    value: productData.product_price,
    currency: 'INR'
  });

  // ─── Scroll animations ───
  var fadeObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        fadeObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.eb-fade-in').forEach(function (el) {
    fadeObserver.observe(el);
  });

  // ─── Scroll depth tracking ───
  var trackObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        var trackName = e.target.getAttribute('data-track');
        var eventMap = {
          'struggles': 'ebook_scroll_struggles',
          'cta-bottom': 'ebook_scroll_bottom'
        };
        if (eventMap[trackName]) {
          fireEvent(eventMap[trackName], {});
        }
        trackObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('[data-track]').forEach(function (el) {
    trackObserver.observe(el);
  });

  // ─── Sticky CTA bar ───
  var stickyBar = document.querySelector('[data-eb-sticky-bar]');
  if (stickyBar) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 600) {
        stickyBar.classList.add('visible');
        fireEvent('ebook_scroll_engaged', {});
      } else {
        stickyBar.classList.remove('visible');
      }
    });
  }

  // ─── Image gallery thumbnails + swipe ───
  var thumbs = document.querySelectorAll('.eb-hero__thumb');
  var mainImg = document.querySelector('.eb-hero__main-image img');
  var activeIndex = 0;

  function showImage(index) {
    if (!thumbs.length || !mainImg) return;
    if (index < 0) index = thumbs.length - 1;
    if (index >= thumbs.length) index = 0;
    activeIndex = index;
    var thumb = thumbs[index];
    var src = thumb.getAttribute('data-full-src');
    var alt = thumb.getAttribute('data-alt');
    if (src) {
      mainImg.src = src;
      mainImg.alt = alt || '';
      thumbs.forEach(function (t) { t.classList.remove('eb-hero__thumb--active'); });
      thumb.classList.add('eb-hero__thumb--active');
    }
  }

  if (thumbs.length && mainImg) {
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { showImage(i); });
    });

    // Swipe support on main image
    var gallery = document.querySelector('.eb-hero__gallery');
    if (gallery) {
      var touchStartX = 0;
      var touchEndX = 0;
      gallery.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      gallery.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) { showImage(activeIndex + 1); }
          else { showImage(activeIndex - 1); }
        }
      }, { passive: true });
    }
  }

  // ─── Variant switching ───
  function failClosedDisableAllCtas(reason) {
    console.error('[bt-ebook-landing] ' + reason + ' — disabling all buy CTAs as fail-closed protection.');
    document.querySelectorAll('[data-eb-buy-link]').forEach(function (el) {
      el.removeAttribute('href');
      el.setAttribute('aria-disabled', 'true');
      el.setAttribute('role', 'link');
      el.classList.add('is-disabled');
      el.textContent = 'Sold Out';
    });
    document.querySelectorAll('button[data-track-action="add_to_cart"]').forEach(function (btn) {
      btn.disabled = true;
      btn.textContent = 'Sold Out';
    });
  }

  var variantsJsonEl = document.querySelector('[data-eb-variants-json]');
  if (variantsJsonEl) {
    var variantsList = null;
    try {
      variantsList = JSON.parse(variantsJsonEl.textContent);
    } catch (e) {
      failClosedDisableAllCtas('Failed to parse variants JSON: ' + e.message);
      variantsList = [];
    }
    if (!Array.isArray(variantsList)) {
      failClosedDisableAllCtas('Variants JSON is not an array.');
      variantsList = [];
    }

    var variantMap = {};
    variantsList.forEach(function (v) { variantMap[String(v.id)] = v; });

    function switchVariant(variantId) {
      var id = String(variantId);
      var variant = variantMap[id];
      if (!variant) {
        console.error('[bt-ebook-landing] switchVariant called with unknown variant id=' + id + '. Picker out of sync with variantsList.');
        return;
      }
      if (variant.available !== true && variant.available !== false) {
        console.warn('[bt-ebook-landing] variant.available is not boolean for id=' + id + '; treating as unavailable.', variant);
      }

      // Update all price displays
      document.querySelectorAll('[data-eb-current-price]').forEach(function (el) {
        el.textContent = variant.price;
      });
      document.querySelectorAll('[data-eb-compare-price]').forEach(function (el) {
        if (variant.compare_at_price) {
          el.textContent = variant.compare_at_price;
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });

      var isAvailable = variant.available === true;

      // Update all Buy Now links (gate on availability)
      document.querySelectorAll('[data-eb-buy-link]').forEach(function (el) {
        var label = el.dataset.originalText || 'Buy Now';
        if (isAvailable) {
          el.setAttribute('href', '/cart/' + id + ':1');
          el.removeAttribute('aria-disabled');
          el.removeAttribute('role');
          el.classList.remove('is-disabled');
          el.innerHTML = label;
        } else {
          el.removeAttribute('href');
          el.setAttribute('aria-disabled', 'true');
          el.setAttribute('role', 'link');
          el.classList.add('is-disabled');
          el.textContent = 'Sold Out';
        }
      });

      // Update all Add to Cart submit buttons
      document.querySelectorAll('button[data-track-action="add_to_cart"]').forEach(function (btn) {
        var label = btn.dataset.originalText || 'Add to Cart';
        btn.disabled = !isAvailable;
        btn.textContent = isAvailable ? label : 'Sold Out';
      });

      // Update all hidden variant inputs
      document.querySelectorAll('[data-eb-variant-input]').forEach(function (el) {
        el.value = id;
      });

      // Sync hero radio buttons
      var heroRadio = document.querySelector('input[name="eb-hero-variant"][value="' + id + '"]');
      if (heroRadio && !heroRadio.checked) heroRadio.checked = true;

      // Sync CTA pills
      document.querySelectorAll('.eb-variant-pill').forEach(function (btn) {
        btn.classList.toggle('eb-variant-pill--active', btn.getAttribute('data-variant-id') === id);
      });

      // Sync sticky bar dropdown
      var stickySelect = document.querySelector('[data-eb-variant-select]');
      if (stickySelect && stickySelect.value !== id) stickySelect.value = id;

      // Update analytics data
      productData.product_price = variant.price;
    }

    // Hero card radio buttons
    document.querySelectorAll('input[name="eb-hero-variant"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        switchVariant(this.value);
      });
    });

    // CTA pill buttons
    document.querySelectorAll('.eb-variant-pill').forEach(function (btn) {
      btn.addEventListener('click', function () {
        switchVariant(this.getAttribute('data-variant-id'));
      });
    });

    // Sticky bar dropdown
    var stickySelectEl = document.querySelector('[data-eb-variant-select]');
    if (stickySelectEl) {
      stickySelectEl.addEventListener('change', function () {
        switchVariant(this.value);
      });
    }
  }

  // ─── Block clicks on disabled Buy Now links (capture phase, before tracking) ───
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[data-eb-buy-link]');
    if (link && link.getAttribute('aria-disabled') === 'true') {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  // ─── CTA click tracking ───
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-track-action]');
    if (!btn) return;
    var action = btn.getAttribute('data-track-action');
    if (action === 'buy_now') {
      fireEvent('ebook_buy_now_click', productData);
      fireMetaEvent('InitiateCheckout', {
        content_type: 'ebook',
        value: productData.product_price,
        currency: 'INR'
      });
    } else if (action === 'add_to_cart') {
      fireEvent('ebook_add_to_cart', productData);
      fireMetaEvent('AddToCart', {
        content_type: 'ebook',
        content_name: productData.product_title,
        value: productData.product_price,
        currency: 'INR'
      });
    } else if (action === 'sticky_buy') {
      fireEvent('ebook_sticky_cta_click', productData);
      fireMetaEvent('InitiateCheckout', {
        content_type: 'ebook',
        value: productData.product_price,
        currency: 'INR'
      });
    }
  });

  // ─── FAQ tracking ───
  document.querySelectorAll('.eb-faq-item').forEach(function (detail) {
    detail.addEventListener('toggle', function () {
      if (detail.open) {
        var q = detail.querySelector('.eb-faq-q');
        var questionText = q ? q.textContent.trim() : '';
        fireEvent('ebook_faq_click_' + questionText.substring(0, 50), {
          event: 'ebook_faq_click',
          question: questionText
        });
      }
    });
  });
});
